var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 13.45L18.62 14.84C18.43 14.94 18.2 14.9 18.04 14.75L16.17 12.88C15.97 12.68 15.97 12.37 16.17 12.17L18.07 10.27C18.22 10.12 18.46 10.08 18.65 10.18L21.4 11.56C22.19 11.94 22.19 13.06 21.4 13.45Z",
    fill: "#346771"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 8.98996C16.61 9.13996 16.67 9.54998 16.43 9.78998L14.76 11.46L14.05 12.17C13.85 12.37 13.54 12.37 13.34 12.17L6.2 5.02997C5.8 4.62997 6.27 3.97998 6.78 4.22998L16.3 8.98996Z",
    fill: "#346771"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.6501V3.98008C2 3.54008 2.53 3.31007 2.85 3.62007L11.62 12.1301C11.83 12.3301 11.82 12.6601 11.61 12.8601L2.84 21.0201C2.52 21.3201 2 21.0901 2 20.6501Z",
    fill: "#346771"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.27 16.0202L6.88001 20.7202C6.37001 20.9702 5.90001 20.3202 6.30001 19.9202L13.35 12.8702C13.55 12.6702 13.86 12.6702 14.06 12.8702L16.41 15.2202C16.64 15.4602 16.57 15.8702 16.27 16.0202Z",
    fill: "#346771"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.f695d8266570073dd98f3b111c52c11e.svg";
export { ForwardRef as ReactComponent };